import { memo } from 'react';
import { Typography } from '@mui/material';
import merge from 'lodash/merge';

const ListParagraph = ({ sx = {}, children }) => {
  const mergedSx = merge({}, sx);
  return (
    <Typography className={'list-subitem list-paragraph'}
                sx={mergedSx}>
      {children}
    </Typography>
  );
};

export default memo(ListParagraph);
